import { render, staticRenderFns } from "./rfq-view.vue?vue&type=template&id=62b1388c&scoped=true"
import script from "./rfq-view.vue?vue&type=script&lang=js"
export * from "./rfq-view.vue?vue&type=script&lang=js"
import style0 from "./rfq-view.vue?vue&type=style&index=0&id=62b1388c&prod&lang=css"
import style1 from "./rfq-view.vue?vue&type=style&index=1&id=62b1388c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b1388c",
  null
  
)

export default component.exports